/**
 * BST Product Feature Columns — slider nav (no dots) + drag scroll track.
 */
const BST_FEATURE_COLUMNS_TRACK = '[data-feature-columns-track]';

class BstProductFeatureColumnsSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector(BST_FEATURE_COLUMNS_TRACK);
    this.prev = this.querySelector('[data-feature-columns-prev]');
    this.next = this.querySelector('[data-feature-columns-next]');

    if (!this.track) return;

    this.onPrev = () => this.scrollBySlide(-1);
    this.onNext = () => this.scrollBySlide(1);
    this.onScroll = () => this.updateNav();
    this.onResize = () => this.updateNav();

    this.prev?.addEventListener('click', this.onPrev);
    this.next?.addEventListener('click', this.onNext);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);

    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.track);
    }

    window.requestAnimationFrame(() => this.updateNav());
  }

  disconnectedCallback() {
    this.prev?.removeEventListener('click', this.onPrev);
    this.next?.removeEventListener('click', this.onNext);
    this.track?.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    this.resizeObserver?.disconnect();
  }

  getSlideStep() {
    const item = this.track?.querySelector('.bst-product-feature-columns__item');
    if (!item || !this.track) return 0;

    const styles = window.getComputedStyle(this.track);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return item.offsetWidth + gap;
  }

  scrollBySlide(direction) {
    const step = this.getSlideStep();
    if (!step) return;

    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    this.track.scrollBy({ left: direction * step, behavior });
  }

  updateNav() {
    if (!this.track) return;

    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    const scrollable = maxScroll > 1;

    if (this.prev) {
      this.prev.disabled = !scrollable || this.track.scrollLeft <= 1;
      this.prev.hidden = !scrollable;
    }

    if (this.next) {
      this.next.disabled = !scrollable || this.track.scrollLeft >= maxScroll - 1;
      this.next.hidden = !scrollable;
    }
  }
}

if (!customElements.get('bst-product-feature-columns-slider')) {
  customElements.define('bst-product-feature-columns-slider', BstProductFeatureColumnsSlider);
}
